/**
 * pdf.js lädt die Datei per fetch — das setzt eine Quelle voraus, die CORS
 * erlaubt. Unser Supabase Storage tut das, Google Drive nicht. Für solche
 * Links bleibt es deshalb beim iframe, sonst bliebe die Fläche leer.
 */
export const istGoogleQuelle = (url: string): boolean =>
  /drive\.google\.com|docs\.google\.com/i.test(url);
